"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var primitives = require('./primitives');
var semantic = require('./semantic');
var support = require('./support');
var typography = require('./typography');

/**
 * @deprecated используйте актуальную палитру цветов из @platform-ui/themes
 */
module.exports = (0, _extends2.default)({}, primitives, semantic, support, typography);